import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useVacationHistoryDataQuery } from '../../hooks/data/useVacationHistoryDataQuery';
import { VacationRequestHistory } from '../VacationRequestHistory';
import { MODAL_TITLE, CLOSE_LABEL } from './vacationCollaboratorHistoryModal.definitions';
import type { VacationCollaboratorHistoryModalProps } from './vacationCollaboratorHistoryModal.types';

export function VacationCollaboratorHistoryModal(props: VacationCollaboratorHistoryModalProps) {
    if (!props.isOpen || !props.collaborator) return null;
    return <VacationCollaboratorHistoryContent {...props} collaborator={props.collaborator} />;
}

function VacationCollaboratorHistoryContent({
    isOpen,
    collaborator,
    onClose,
}: VacationCollaboratorHistoryModalProps & { collaborator: NonNullable<VacationCollaboratorHistoryModalProps['collaborator']> }) {
    const { requests, collaborators } = useVacationHistoryDataQuery();

    const collaboratorRequests = requests.filter(
        (r) =>
            r.collaboratorId === collaborator.id || r.collaboratorEmail === collaborator.email
    );

    const collaboratorData = collaborators.find(
        (c) => c.id === collaborator.id || c.email === collaborator.email
    );

    const vacationPeriods = collaboratorData?.vacationPeriods || [];

    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-50">
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

            <div className="fixed inset-0 flex items-center justify-center p-4">
                <Dialog.Panel className="flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white shadow-xl">
                    <div className="border-b border-gray-200 px-7 py-5 flex items-center justify-between">
                        <div>
                            <Dialog.Title className="text-lg font-semibold text-raro-gray-900 font-montserrat">
                                {MODAL_TITLE}
                            </Dialog.Title>
                            <p className="text-sm text-gray-600 mt-1">
                                {collaborator.name}
                            </p>
                        </div>

                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 transition-colors"
                            title={CLOSE_LABEL}
                        >
                            <XMarkIcon className="h-6 w-6" />
                        </button>
                    </div>

                    <div className="min-h-0 flex-1 overflow-y-auto px-7 py-5">
                        <VacationRequestHistory
                            requests={collaboratorRequests}
                            vacationPeriods={vacationPeriods}
                        />
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
}
